import api from "../utils/axios/axiosConfig";

const providersService = {
  create: (data) => api.post("/providers/create", data),
  update: (id, data) => api.put(`/providers/update/${id}`, data),
  delete: (id) => api.delete(`/providers/delete/${id}`),
  get: (id) => api.get(`/providers/get/${id}`),
  search: (params) => api.post("/providers/search", params),
  searchAll: () => api.get("/providers/search-all"),
};

export default providersService;
